import React from 'react';

import { useResponsiveBreakpoints } from '../../../hooks/useResponsiveBreakpoints';

import { cyclesSortOptions } from '../../../constants/sort';

import SortControls from '../../../components/SortControls/SortControls';
import SearchBarWithUrlParamsHandling from '../../../components/SearchBarWithUrlParamsHandling/SearchBarWithUrlParamsHandling';

const CyclesIndexTopControls = () => {
    const { isMobile, isDesktop } = useResponsiveBreakpoints({ maxMobileWidth: 480 });
    const sortDropdownPosition = isDesktop ? { top: '120%', left: 0 } : { top: '42px', right: 0 };

    return (
        <div className="flex items-center gap-2">
            <SearchBarWithUrlParamsHandling
                size="xs"
                maxWidth={isMobile ? '100%' : 300}
                placeholder="Search by name"
            />

            <SortControls
                sortOptions={cyclesSortOptions}
                variant="primary"
                dropdownPosition={sortDropdownPosition}
                buttonContainerClassName="relative"
            />
        </div>
    );
};

export default CyclesIndexTopControls;
